import React from 'react';

import { flagStyles } from '../settings';

const SvgGN = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-2016px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgGN;
